/* global hbspt */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "./v2/Modal";

const HubspotRequestDemoModal = ({ onClose, show }) => {
  useEffect(() => {
    if (typeof hbspt === "undefined") {
      const head = document.getElementsByTagName("head").item(0);
      const js = document.createElement("script");
      js.setAttribute("type", "text/javascript");
      js.setAttribute("src", "//js.hsforms.net/forms/v2.js");
      js.setAttribute("defer", "true");
      js.async = true;
      head.appendChild(js);
    }
  }, []);

  useEffect(() => {
    if (!show) return;
    hbspt.forms.create({
      portalId: "6041126",
      formId: "c0592518-30e7-46d6-8b94-f6d8e79af7e7",
      target: "#hb-request-demo",
    });
  }, [show]);

  return (
    <Modal
      onHide={onClose}
      show={show}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header closeButton />
      <Modal.Body id="hb-request-demo" />
    </Modal>
  );
};

HubspotRequestDemoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default HubspotRequestDemoModal;
